import { render, staticRenderFns } from "./BlogCard.vue?vue&type=template&id=4bb545f8&scoped=true&"
import script from "./BlogCard.vue?vue&type=script&lang=ts&"
export * from "./BlogCard.vue?vue&type=script&lang=ts&"
import style0 from "./BlogCard.vue?vue&type=style&index=0&id=4bb545f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb545f8",
  null
  
)

export default component.exports